import { cn } from '@navinc/base-react-components'
import { InferComponentProps } from '@navinc/base-react-components'
import { FC } from 'react'

import { LexicalRichText } from './lexical.jsx'
import { Children, serialize } from './serialize.js'

type SlateRichTextProps = { content?: Children; className?: string }

const SlateRichText: FC<SlateRichTextProps> = ({ content, className }) => {
  if (!content) {
    return null
  }

  return <div className={cn('first:mt-0 last:mb-0 w-full', className)}>{serialize(content)}</div>
}

type LexicalRichTextProps = InferComponentProps<typeof LexicalRichText>

export const RichText = (props: LexicalRichTextProps | SlateRichTextProps) => {
  if (props.content && 'root' in props.content) {
    return <LexicalRichText {...(props as LexicalRichTextProps)} />
  }

  return <SlateRichText {...(props as SlateRichTextProps)} />
}
